// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"about-us-m__wrapper__49dtt","summary":"about-us-m__summary__1HyaY","statement":"about-us-m__statement__2freN"};